import { getCertKind, getEOCertKind } from '../../CertsDetailsList/Tile/utils';
import { ROLE_TYPES } from '../CertsActionButtonsGroup/constants';

import { ENTITLEMENT, ROLE } from './constants';

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

/**
 *
 * @returns  title for the reassignment modal
 */

export const getReassignSubTitle = (isEOCampaign, nodeData, l) => {
  const certsKind = isEOCampaign
    ? getEOCertKind(nodeData)
    : getCertKind(nodeData);

  if (
    certsKind === ENTITLEMENT ||
    (certsKind === ROLE &&
      nodeData?.Role_ROLETYPE === ROLE_TYPES.APPLICATION_ROLE)
  ) {
    return l(
      'Assign the {lineItem} to another certifier and provide a reason. Any approvals or rejections will be cleared upon reassignment.',
      {
        lineItem: l(certsKind).toLocaleLowerCase(),
      }
    );
  }

  return l(
    'Assign the {lineItem} and their associated items to another certifier, and provide a reason. Any approvals or rejections will be cleared upon reassignment.',
    {
      lineItem: l(certsKind).toLocaleLowerCase(),
    }
  );
};
